// Libs
import 'pepjs'
const modernizr = require("modernizr");
import PinchZoom from 'vue-pinch-zoom';

// Componenten
import Footer from './components/Footer';
import Header from './components/Header';
import Help from './components/Help';
import InfoBox from './components/InfoBox';
import TextBanner from './components/TextBanner';
import Fallback from './components/Fallback';
import Apng from './components/Apng';
import FullscreenContainer from './components/FullscreenContainer';
import FullscreenImage from './components/FullscreenImage';
import ZDFPlayer from "./components/ZDFPlayer";
import PageNotFound from "./components/PageNotFound";

// Tools
import EventBus from "./tools/event-bus";
import Tracking from "./tools/Tracking";
import AudioController from "./tools/AudioController";
import URL from "./tools/URL";
import preventDoubleClick from "./tools/preventDoubleClick";

export default {
    install(Vue, data)
    {
        Vue.prototype.$tracking = new Tracking(data.config.tracking, data.router);
        Vue.prototype.$eventBus = EventBus;

        // Babylon JS
        this.loadBabylon(Vue, data);

        // Seiten Title
        data.router.afterEach((to) =>
        {
            document.title = 'ZDF ' + data.config.tracking.storyName
                + (to.meta.title ? ' - ' + to.meta.title : '');
        });

        // 404 Weiterleitung auf Start
        data.router.addRoutes([
            {
                path: '*',
                component: PageNotFound
            }
        ]);

        // Audio Controller
        Vue.prototype.$audioController = new AudioController();

        // preventDoubleClick event
        Vue.directive('on-single-click', {
            bind(el, binding)
            {
                let myFunction = binding.value;
                el.addEventListener('click', (event) =>
                {
                    preventDoubleClick(event);
                    myFunction(event);
                });
            }
        });

        // Komponenten für Seiten
        Vue.component('Footer', Footer);
        Vue.component('Header', Header);
        Vue.component('Help', Help);
        Vue.component('InfoBox', InfoBox);
        Vue.component('TextBanner', TextBanner);
        Vue.component('Fallback', Fallback);
        Vue.component('Apng', Apng);
        Vue.component('FullscreenContainer', FullscreenContainer);
        Vue.component('FullscreenImage', FullscreenImage);
        Vue.component('ZDFPlayer', ZDFPlayer);
        Vue.component('pinch-zoom', PinchZoom);

        Vue.mixin({
            methods: {
                infobox(box)
                {
                    // fallback hotspot v-on:click
                    this.$eventBus.$emit('InfoBox.show', box);
                }
            }
        });
    },

    /**
     * Babylon JS laden oder Fallback Lösung mit statischen Bildern, wenn 3D nicht geht
     * @param Vue
     * @param data
     */
    loadBabylon(Vue, data)
    {
        // ohne webGL => Fallback auf statische Bilder ohne 3D
        let fallback = !(modernizr.webgl && modernizr.webglextensions);

        // Fallback per Parameter anschalten zum Testen
        if (URL.hasQuery('fallback'))
        {
            fallback = !!URL.getQuery('fallback');
        }

        window.BABYLON_FALLBACK = fallback;
        document.querySelector('html').classList.add((fallback) ? 'no-babylon' : 'babylon');

        if (!fallback)
        {
            import(/* webpackChunkName: "BabylonController" */ "./babylon/Controller.js").then((imported) =>
            {
                let babylonController = imported.default;
                Vue.prototype.$babylonController = babylonController;
                // Babylon Controller starten, wenn Seite geladen wurde
                document.onreadystatechange = () =>
                {
                    if (document.readyState === "complete" && !fallback)
                    {
                        babylonController.init(data.config);
                    }
                };
            });
        }

        Vue.mixin({
            mounted: function ()
            {
                const fct = () =>
                {
                    // Set Babylone State from babylonState option
                    if (this.$options.babylonState)
                    {
                        this.$babylonController.setState(this.$options.babylonState);
                    }
                    // call babylonReady
                    if (this.$options.babylonReady)
                    {
                        this.$options.babylonReady.bind(this)();
                    }
                };

                if (this.$babylonController && this.$babylonController.ready)
                {
                    fct();
                }
                else
                {
                    EventBus.$on('BABYLON.Loaded', fct);
                }
            }
        });
    }
}